import { Pipe, PipeTransform } from '@angular/core';
import { hasIn } from 'lodash-es';

@Pipe({
  name: 'prettyReadSign',
})
export class PrettyReadSignPipe implements PipeTransform {
  transform(readValue: any): string {
    if (hasIn(readValue, 'description')) {
      return readValue.description || 'ERROR';
    }
    return '';
  }
}
